import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { CorePageWrapper } from '../../designSystem/layouts/pageWrappers/CorePageWrapper';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { PageHeader } from '../../designSystem/PageHeader';
import { H2 } from '../../designSystem/typography/Heading';

export default function ErrorPage(): JSX.Element 
{
    const urlQuerySegment = useLocation().search;
    const message = new URLSearchParams(urlQuerySegment).get('message');

    return (
        <CorePageWrapper activeUser={null} loading={false} hideMenu>
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        <PageHeader headerText="Der opstod en fejl" headerStyle="secondary-gray" />

                        {message 
                            ? <div dangerouslySetInnerHTML={{__html:message}} /> 
                            :
                            <>
                                <H2>Hov, det var ikke godt ....</H2>
                                <p>
                                    Det ser ud til at der opstod en fejl.<br />
                                    <br />
                                    Vi vil blive glade hvis du vil skrive eller ringe til os,
                                    så vi kan få rettet den i en fart.<br />
                                    <br />
                                    Mvh. AMORG
                                </p>
                            </>
                        }
                    </>
                }
            />
        </CorePageWrapper>

    );
}